module.exports = __webpack_public_path__ + "img/红兔详情.3cea4d0c.jpg";